import type { ChangeEvent, ReactNode } from "react";
import { formatPhoneNumber } from "../../utils/formatPhoneNumber";

interface PhoneNumberInputFieldProps {
  id: string;
  label: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (rawValue: string) => void;
  icon?: ReactNode;
  autoComplete?: string;
}

export const PhoneNumberInputField = ({
  id,
  label,
  type = "tel",
  placeholder = "",
  value,
  autoComplete = "tel",
  onChange,
  icon,
}: PhoneNumberInputFieldProps) => {
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^\d]/g, "").slice(0, 10);
    onChange(rawValue);
  };

  return (
    <div className="w-full relative">
      <label
        htmlFor={id}
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {label}
      </label>
      <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
        {icon || (
          <svg
            className="w-4 h-4 translate-y-1/2 mt-2.5 text-gray-500"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 19 18"
          >
            <path d="M18 13.446a3.02 3.02 0 0 0-.946-1.985l-1.4-1.4a3.054 3.054 0 0 0-4.218 0l-.7.7a.983.983 0 0 1-1.39 0l-2.1-2.1a.983.983 0 0 1 0-1.389l.7-.7a2.98 2.98 0 0 0 0-4.217l-1.4-1.4a2.824 2.824 0 0 0-4.218 0c-3.619 3.619-3 8.229 1.752 12.979C6.785 16.639 9.45 18 11.912 18a7.175 7.175 0 0 0 5.139-2.325A2.9 2.9 0 0 0 18 13.446Z" />
          </svg>
        )}
      </div>
      <input
        type={type}
        id={id}
        value={formatPhoneNumber(value)}
        onChange={handleInputChange}
        autoComplete={autoComplete}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg pl-10 focus:ring-z-dark-moss-green focus:border-z-dark-moss-green block w-full p-2.5"
        placeholder={placeholder}
      />
    </div>
  );
};
